<template>
  <div>
    <header-support :active-section="4" />

    <stockholm-support-contact-info
      v-if="$store.state.dermicusPlatform === 'stockholm'"
      data-testid="stockholm-support-contact-info"
    />

    <skane-support-contact-info
      v-else-if="$store.state.dermicusPlatform === 'skane'"
      data-testid="skane-support-contact-info"
    />

    <div v-else data-test="support-contact-default">
      <div class="mt-4">
        <h5 class="text-center text-uppercase">
          {{ trans("support.contactUs") }}
        </h5>
        <p class="text-center w-75 m-auto">
          {{ trans("support.contactUsInfoText") }}
        </p>
      </div>

      <section
        v-if="appConfig && appConfig.company"
        class="contact my-3 tab-content"
      >
        <div class="container">
          <div class="row text-center">
            <div class="col-sm-12 col-md-6 col-lg-4 my-3">
              <div class="card border-0">
                <div class="card-body text-center">
                  <i class="fas fa-phone fa-2x mb-3" aria-hidden="true" />
                  <h6 class="text-uppercase mb-3">
                    {{ trans("support.callUs") }}
                  </h6>
                  <p data-test="support-contact-phone">
                    {{ appConfig.company.support.phone }}
                    <br />
                    {{ trans("support.supportTime") }}: 8:00 - 17:00
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-6 col-lg-4 my-3">
              <div class="card border-0">
                <div class="card-body text-center">
                  <i class="fas fa-envelope fa-2x mb-3" aria-hidden="true" />
                  <h6 class="text-uppercase mb-3">Email</h6>
                  <p>
                    <a
                      :href="`mailto:${appConfig.company.support.email}`"
                      data-test="support-contact-email"
                    >
                      {{ appConfig.company.support.email }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-4 my-3">
              <div class="card border-0">
                <div class="card-body text-center">
                  <i class="fas fa-headset fa-2x mb-3" aria-hidden="true" />
                  <h6 class="text-uppercase mb-3">
                    {{ trans("support.serviceDesk") }}
                  </h6>
                  <p>
                    <a
                      href="https://gnosco.atlassian.net/servicedesk/customer/portal/10"
                      data-test="support-contact-service-desk"
                    >
                      {{ trans("support.serviceDesk") }}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div class="container d-flex justify-content-center">
          <div class="col-sm-12 col-md-12 col-lg-6 text-center card border-0">
            <i class="fas fa-map-marker-alt fa-2x mb-3" />
            <h6 class="text-uppercase mb-3 text-center">Göteborg</h6>
            <p>
              Omda Dermicus AB
              <br />Sankt Eriksgatan 5 <br />411 05 Göteborg <br />Sweden
              <br />
              <a :href="`mailto:${appConfig.company.contact.email}`">
                {{ appConfig.company.contact.email }}
              </a>
            </p>

            <div class="google-map mb-3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4262.810780741426!2d11.962891778483659!3d57.70957137387093!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x464ff3614ecd3735%3A0xa51dd3d1a8b24ff1!2sSankt%20Eriksgatan%205%2C%20411%2005%20G%C3%B6teborg!5e0!3m2!1sen!2sse!4v1761742681590!5m2!1sen!2sse"
                width="400"
                height="300"
                style="border: 0"
                allowfullscreen
                aria-hidden="false"
                tabindex="0"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script setup>
import { useAsyncState } from "@vueuse/core";
import { appConfigGet } from "../../app/practitioner-portal/store/app-config";

const { state: appConfig } = useAsyncState(
  appConfigGet().then((response) => response.data),
  {
    company: { support: {}, contact: {} },
  },
);
</script>
<script>
import HeaderSupport from "./Header.vue";
import SkaneSupportContactInfo from "./RegionsSupport/SkaneSupportContactInfo.vue";
import StockholmSupportContactInfo from "./RegionsSupport/StockholmSupportContactInfo.vue";

export default {
  components: {
    HeaderSupport,
    StockholmSupportContactInfo,
    SkaneSupportContactInfo,
  },
};
</script>

<style lang="scss" scoped>
@use "/resources/assets/sass/abstracts/variables";

.card:hover i,
.card:hover h5 {
  color: variables.$dermicusBlue;
  transition: all 0.3s;
}
</style>
